import $ from 'jquery';

$(function() {
	var formData = null;
	// close button 
	$("#cwm-myaccountformClose" ).on( "click", function() { 
		$(".cwm-account-form").animate({height: "auto"}, function() {
			$(this).hide();
			window.location.reload();
			
		});	
		$("a.edit-view-details").show();	
		$('html,body').animate({
			scrollTop: $(".cwm-view-details").offset().top - 100},'1000');
	});	
	// enable and disable submit button
	$('#my-account_Detailsform input.my-account_formControl').on('keyup',function() {
		if( $("#cwmaf_firstName").val() != '' || $("#cwmaf_surName").val() != '' || 
			$("#cwmaf_email").val() != '' || $("#cwmaf_date").val()!= '' || 
			$("#cwmaf_addressOne").val() != '' || $("#cwmaf_postcode").val() != ''||
			$("#cwmaf_telnumber").val() != '' || $("#cwmaf_addressTwo").val() != '' ||
			$("#cwmaf_city").val() != '' || $("#cwmaf_county").val() != '') {

			$('#myaccountdetailsSubmit').attr('disabled' , false);
		} else {
			$('#myaccountdetailsSubmit').attr('disabled' , true);
		}
	});
	//Select Dropdown
	$('#my-account_Detailsform select#cwmaf_country').on('change',function() {
		var val = this.value;
		if (val != '') {
			$('#myaccountdetailsSubmit').attr('disabled' , false);
		} else {
			$('#myaccountdetailsSubmit').attr('disabled' , true);
		}
	  });
	  $('#cwmaf_postcode').keyup(function() {
        this.value = this.value.toLocaleUpperCase();
    });
	
	$("#cwmaf_surName").keypress(function(e) {
		var numbers = ['0','1','2','3','4','5','6','7','8','9'];
		var keynum;	  
		if (window.event) { // IE                    
		  keynum = e.keyCode;
		} else if (e.which) { // Netscape/Firefox/Opera                   
		  keynum = e.which;
		}	  
		if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
		  e.preventDefault();
		}
	  });
	  $("#cwmaf_firstName").keypress(function(e) {
		var numbers = ['0','1','2','3','4','5','6','7','8','9'];
		var keynum;	  
		if (window.event) { // IE                    
		  keynum = e.keyCode;
		} else if (e.which) { // Netscape/Firefox/Opera                   
		  keynum = e.which;
		}	  
		if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
		  e.preventDefault();
		}
	  });
	  
	//CONTACT FORM: ajax request
	$('#myaccountdetailsSubmit').on( "click", function() {

		// assigning form values and names in to var
		formData = {
			FirstName: { FieldName: "firstName", FieldValue: $("#cwmaf_firstName").val() },
			LastName: { FieldName: "surName", FieldValue: $("#cwmaf_surName").val() },
			Email: { FieldName: "email", FieldValue: $("#cwmaf_email").val() },
			//JobTittle: { FieldName: "jobTitle", FieldValue: $("#jobTitle").val() },
			DateOfBirth: { FieldName: "date", FieldValue: $("#cwmaf_date").val() },
			Address1: { FieldName: "addressOne", FieldValue: $("#cwmaf_addressOne").val() },
			Address2: { FieldName: "addressTwo", FieldValue: $("#cwmaf_addressTwo").val() },
			City: { FieldName: "city", FieldValue: $("#cwmaf_city").val() },
			County: { FieldName: "county", FieldValue: $("#cwmaf_county").val() },
			Country: { FieldName: "country", FieldValue: $("#cwmaf_country").val() },
			PostCode: { FieldName: "postcode", FieldValue: $("#cwmaf_postcode").val() },
			Phone: { FieldName: "telnumber", FieldValue: $("#cwmaf_telnumber").val() }
		}
			
		//onlynumbers and Uppercase letters
		$.validator.addMethod("postalcode", function(value, element) {
			return this.optional(element) || value == value.match(/^[A-Z0-9\s]*$/);
		});
		//onlynumbers and Phone number(/^[0-9 -.\s]+$/)
		$.validator.addMethod("phonenumber", function(value, element) {
			return this.optional(element) || value == value.match(/^[0-9 + ]+$/);
		});
		//only accept letters  /^[A-Za-zÀ-ÖØ-öø-ÿ `!@#$%\^&*)(+=._-\s]*$/
		$.validator.addMethod("letters", function(value, element) {
			return this.optional(element) || value == value.match(/[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+'?[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+/g);
		});
		//Date dd/mm/yyyy validation
		$.validator.addMethod(
			"validDate",
			function(value, element) {
				return value.match(/(?:0[1-9]|[12][0-9]|3[01])\/(?:0[1-9]|1[0-2])\/(?:19\d{2}|20\d{2})/);
			},
		);
		//validation for 18 years old
		$.validator.addMethod(
			"validDOB",
			function(value, element) {              
				var from = value.split("/"); // DD/MM/YYYY
				var day = from[0];
				var month = from[1];
				var year = from[2];
				var age = 18;
				var mydate = new Date();
				mydate.setFullYear(year, month-1, day);		
				var currdate = new Date();
				var setDate = new Date();
	
				setDate.setFullYear(mydate.getFullYear() + age, month-1, day);
	
				if ((currdate - setDate) > 0){
					return true;
				}else{
					return false;
				}
			},
		);
	
		//FORM VALIDATION: validates on submit
		$("#my-account_Detailsform").validate({
			// error message adding in span with class name 
			wrapper: 'span',
			errorPlacement: function (error, element) {
				error.addClass("my-account_errorlabel")
				error.insertAfter(element);
			},
			rules: {
				cwmaf_firstName: {           //input name: firstName
					required: true,   //required boolean: true/false
					maxlength: 255,
					letters:true 
				},
				cwmaf_surName: {
					required: true,   //required boolean: true/false
					maxlength: 255,
					letters:true   
				},
				cwmaf_email: {          
					required: true,
					email: true       
				},
				cwmaf_date: {           
					required: true,   
					validDate: true,  
					validDOB: true
				},
				cwmaf_addressOne: {
					required: true,   
					maxlength: 255
				},
				cwmaf_country: {
					required: true
				},
				cwmaf_postcode: {
					required: true,
					postalcode: true,
					maxlength: 8
				},
				cwmaf_telnumber: {
					required: true,
					phonenumber: true,
					maxlength: 18
				},
				cwmaf_addressTwo: {
					maxlength: 255
				},
				cwmaf_county: {
					maxlength: 255
				},
				cwmaf_city: {
					maxlength: 255
				}
			},
			messages: {               
				cwmaf_firstName: {
					required: "Please enter first name.",
					letters: "Please enter text only.",
					maxlength: "Please enter no more than 255 charaters."
				},
				cwmaf_surName: {
					required: "Please enter surname.",
					letters: "Please enter text only.",
					maxlength: "Please enter no more than 255 charaters."
				},
				cwmaf_email: {
					required: "Please enter email address.",
					email: "Please enter a valid email address."
				},
				cwmaf_date: {
					required: "Please enter your DOB in the format DD/MM/YYYY.",
					validDOB: "You must be age 18 or over.",
					validDate: "Please enter your DOB in the format DD/MM/YYYY"

				},
				cwmaf_addressOne: {
					required: "Please enter the 1st line of your address.",
					maxlength: "Please enter no more than 255 characters."
				},
				cwmaf_country: {
					required: "Please select country."
				},
				cwmaf_postcode: {
					required: "Please enter postcode.",
					postalcode: "Please enter a valid postcode.",
					maxlength: "Please enter no more than 8 characters."
				},
				cwmaf_telnumber: {
					required: "Please enter a phone number.",
					phonenumber: "Please enter a valid phone number.",
					maxlength: "Please enter no more than 15 numbers."
				},
				cwmaf_addressTwo: {
					maxlength: "Please enter no more than 255 characters."
				},
				cwmaf_county: {
					maxlength: "Please enter no more than 255 characters."
				},
				cwmaf_city: {
					maxlength: "Please enter no more than 255 characters."
				}
			},		
			
			submitHandler: function(form) {
				$('html').css({ 'overflow-y': "hidden" });
				$("#cwm-overlay").show();
				$.ajax({
					url: form.action,
					type: form.method,
					data: this.formData = formData,
					dataType: "json",
					success: function(response) { 
						$('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
						$(".my-account_Wrapper").hide();
						$('#form-successful-messgae').show(); 
						$("a.edit-view-details").show();
						console.log(JSON.stringify(formData));
						$('html,body').animate({
							scrollTop: $("#form-successful-messgae").offset().top - 100},'1000');
					},
					error: function(response) {
						$('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
						console.log(response.error);
					}            
				});
			}
		});  
	});	
});

  


// WEBPACK FOOTER //
// ./components/cwm-my-account-details/scripts/my-account-details.js